export const productType = {
  Subscription: 1,
  Certificate: 2,
  Booking: 3
};

export const qtyClients = [1,2,3,4,5,6,7,8,9,10];

export const paymentSystem = {
  Sbrf: 1,
  Raif: 2,
  Credit: 3,
  TinkoffCard: 4,
  CloudPayments: 5,
  SberPay: 6,
};

export const trainerSelectionRequirement = {
   None: 0,
   ClientChoose: 1,
   UserChoose: 2,
   Both: 3
};

export const clientProfileFields = {
  None: 0,
  Name: 1,
  Birthday: 2,
  Sex: 4,
  Email: 8
};
